<template>
  <modal
    name="MessageDialog"
    :shift-y="0.35"
    :click-to-close="false"
    :width="size.width"
    :height="size.height"
    :styles="{ backgroundColor: 'transparent', boxShadow: 'none' }"
    @before-open="beforeOpen"
    @opened="isShow = true"
    @closed="isShow = false"
  >
    <div
      class="rootDom"
      :style="{ width: size.width + 'px', height: size.height + 'px' }"
    >
      <div class="titleDom">
        <span class="title">{{ title }}</span>
        <div
          v-if="showCloseBtn"
          class="close-btn"
          @click="hide('Close')"
        >
          <!-- <iconfont
            name="#icon13-31guanbi"
            font-size="12px"
          ></iconfont>-->
          <close-button></close-button>
        </div>
      </div>
      <div class="contentDom">
        <span class="content">{{ content }}</span>
        <div
          v-if="btns && btns.length > 0"
          class="btnDom"
        >
          <div
            v-for="(btn, index) in btns"
            :key="index"
            class="button"
            :class="[btn.className]"
            @click="handBtnClick(btn.type)"
          >
            {{ btn.content }}
          </div>
        </div>
        <div
          v-if="showRemind"
          class="remind"
        >
          <label>
            <input
              v-model="noRemind"
              type="checkbox"
              class="check-box"
            >
            <span></span>
            {{ remindContent }}
          </label>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
// 按钮 （"Ok"，"Delete"，"Cancel"， "Close"为预定义按钮。也可以按格式添加自定义按钮。
//除Close按钮外，其他按钮根据数组顺序排列布局,）
export default {
  name: 'MessageDialog',
  components: {
    CloseButton: () => import('@/components/common/closeButton')
  },
  props: {},
  data() {
    return {
      waiting: false,
      isShow: false,

      title: '', //标题
      content: '', //内容
      btns: [], //按钮
      noRemind: false,
      remindContent: '',
      showCloseBtn: false, //是否显示关闭按钮
      showRemind: false, //
      resultHandler: null, //事件处理函数
      size: { width: 478, height: 210 }, //窗口大小

      pre_defined_btns: {
        Ok: { type: 'Ok', content: '确认', className: 'button-Ok' },
        Cancel: { type: 'Cancel', content: '取消', className: 'button-Cancel' },
        Delete: { type: 'Delete', content: '删除', className: 'button-Delete' }
      }
    };
  },
  computed: {},
  watch: {},
  methods: {
    beforeOpen(ev) {
      this.init();

      this.title = ev.params.title;
      this.content = ev.params.content;
      let str = ev.params.remind;
      if (typeof str != 'undefined' && str != null && str != '') {
        this.showRemind = true;
        this.remindContent = str;
      }

      this.size = ev.params.size || this.size;
      let inputBtns = ev.params.btns || [];

      for (const key in inputBtns) {
        let btn = inputBtns[key];
        if (typeof btn == 'object') {
          if (Object.prototype.hasOwnProperty.call(btn, 'type') && Object.prototype.hasOwnProperty.call(btn, 'content')) {
            btn.className = 'button-Customize';
            this.btns.push(btn);
          }
        } else if (typeof btn == 'string') {
          if (this.pre_defined_btns[btn]) {
            this.btns.push(this.pre_defined_btns[btn]);
          } else if (btn === 'Close') {
            this.showCloseBtn = true;
          }
        }
      }
      if (typeof ev.params.resultHandler == 'function') {
        this.resultHandler = ev.params.resultHandler;
      }
    },
    init() {
      this.title = ''; //标题
      this.content = ''; //内容
      this.btns = []; //按钮
      this.showRemind = false; //是否显示不在提醒
      this.remindContent = ''; //不在提醒文案
      this.showCloseBtn = false; //是否显示关闭按钮
      this.resultHandler = null; //事件处理函数
      this.size = { width: 478, height: 210 };
    },
    handBtnClick(type) {
      this.hide(type);
    },
    hide(type) {
      this.$modal.hide('MessageDialog');
      if (this.resultHandler) {
        this.resultHandler({ type: type, noRemind: this.noRemind });
      }
      this.init();
    }
  }
};
</script>

<style scoped lang="scss">
.rootDom {
  position: relative;
  margin: auto;
  background-color: #ffffff;
  box-shadow: 0px 0px 4px 0px rgba(54, 76, 204, 0.4);
  border-radius: 4px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  .titleDom {
    position: relative;
    height: 40px;
    width: 100%;
    .title {
      display: inline-block;
      position: absolute;
      left: 0;
      font-size: 16px;
      line-height: 40px;
      text-align: left;
      padding-left: 16px;
    }
    .close-btn {
      position: absolute;
      top: 16px;
      right: 16px;
      cursor: pointer;
    }
  }
  .contentDom {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    .content {
      display: inline-block;
      color: #343434;
      font-size: 14px;
      font-weight: bold;
      margin-top: 10px;
      margin-bottom: 30px;
    }
    .btnDom {
      height: 40px;
      width: 362px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 1;
      .button {
        width: 120px;
        height: 40px;
        font-size: 14px;
        border-radius: 4px;

        text-align: center;
        line-height: 40px;
        cursor: pointer;
        flex-shrink: 1;
        margin-left: 15px;
        margin-right: 15px;
      }
      .button-Ok {
        color: #fff;
        background-color: #3058fe;
        border-color: #3058fe;
        &:hover {
          background-color: #3e7eff;
          border-color: #3e7eff;
        }
      }

      .button-Cancel {
        background-color: #ffffff;
        border: 1px solid #d6d6d6;
        color: #343434;
        &:hover {
          border-color: #3058fe;
          color: #3058fe;
        }
      }
      .button-Delete {
        background-color: #ea3d45;
        border-color: #ea3d45;
        color: #fefefe;
      }

      .button-Customize {
        color: #fff;
        background-color: #3058fe;
        border-color: #3058fe;
        &:hover {
          background-color: #3e7eff;
          border-color: #3e7eff;
        }
      }
    }
    .remind {
      width: 100%;
      margin-top: 30px;
      & > label {
        display: flex;
        align-items: center;
        justify-content: center;

        .check-box {
          display: none;
        }
        .check-box + span {
          width: 14px;
          height: 14px;
          border: 1px solid #9a9a9a;
          display: inline-block;
          border-radius: 2px;
          margin-right: 5px;
        }
        .check-box:checked + span {
          background-color: #fff;
          position: relative;
        }
        .check-box:checked + span:after {
          content: '\2714';
          color: #9a9a9a;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          font-size: 10px;
        }

        font-size: 14px;
        color: #9a9a9a;
      }
    }
  }
}
</style>
